import React from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { useSelector } from "react-redux";
import RTL from "./layouts/full-layout/customizer/RTL";
import ThemeSettings from "./layouts/full-layout/customizer/ThemeSettings";
import "react-perfect-scrollbar/dist/css/styles.css";
import { AuthProvider } from "./authentication/AuthProvider";
import AppWrapper from "./app-wrapper";
import "./css/loader.css";
// import { useEffect } from "react";
// import { createChat } from "@n8n/chat";
import "@n8n/chat/dist/style.css";

const App = () => {
  const theme = ThemeSettings();
  const customizer = useSelector((state) => state.CustomizerReducer);
  // useEffect(() => {
  //   createChat({
  //     webhookUrl:
  //       "https://ronakjadav.app.n8n.cloud/webhook/d25955b8-ade5-4ff0-a42f-8f31e219dd8d/chat",
  //     title: "S.S White Support", 
  //     subtitle: "We're here to help you",
  //       initialMessages: [
  //   "Hello! 👋",
  //   "Welcome to S.S White Support. How can we assist you today?"
  // ]
  //   });
  // }, []);
  return (
    <ThemeProvider theme={theme}>
      <RTL direction={customizer.activeDir}>
        <CssBaseline />
        <AuthProvider>
          <AppWrapper />
        </AuthProvider>
      </RTL>
    </ThemeProvider>
  );
};

export default App;
